// @flow
import * as service from './categoriesService';
import actionKeys from './categoriesActionKeys';
import type { Category, CategoryOptIn, CategoryOptInToSet } from '../../types';

type spidType = (number | string);
type categoryPayLoad = {|data: {|serviceProviderId: spidType|}, promise: any|};

// We pass a non-promise object to payload here so that request is populated in redux
export const getServiceProviderCategories = (serviceProviderId: spidType): {|
  payload: categoryPayLoad,
  type: any,
|} => ({
  type: actionKeys.GET_SERVICE_PROVIDER_CATEGORIES,
  payload: {
    data: { serviceProviderId },
    promise: service.getServiceProviderCategories(serviceProviderId),
  },
});

export const getCategoriesWithMetrics = (serviceProviderId: spidType): {|
  payload: categoryPayLoad,
  type: any,
|} => ({
  type: actionKeys.GET_CATEGORIES_WITH_METRICS,
  payload: {
    data: { serviceProviderId },
    promise: service.getCategoriesWithMetrics(serviceProviderId),
  },
});

export const addCategoriesToServiceProvider = (
  serviceProviderId: spidType,
  categories: Array<Category>,
): {|
  payload: {|
    data: {|categories: Array<Category>, serviceProviderId: spidType|},
    promise: any,
  |},
  type: any,
|} => ({
  type: actionKeys.ADD_CATEGORIES_TO_SERVICE_PROVIDER,
  payload: {
    data: { serviceProviderId, categories },
    promise: service.addCategoriesToServiceProvider({ serviceProviderId, categories }),
  },
});

export const removeCategoriesFromServiceProvider = (
  serviceProviderId: spidType,
  categoryIds: Array<number>,
): {|
  payload: {|
    data: {|categoryIds: Array<number>, serviceProviderId: spidType|},
    promise: any,
  |},
  type: any,
|} => ({
  type: actionKeys.REMOVE_CATEGORIES_FROM_SERVICE_PROVIDER,
  payload: {
    data: { serviceProviderId, categoryIds },
    promise: service.removeCategoriesFromServiceProvider({ serviceProviderId, categoryIds }),
  },
});

export const setCategoryOptIn = (
  serviceProviderId: spidType,
  optIn: CategoryOptInToSet,
): {|
  payload: {|
    data: {|optIn: CategoryOptInToSet, serviceProviderId: spidType|},
    promise: any,
  |},
  type: any,
|} => ({
  type: actionKeys.SET_CATEGORY_OPT_IN,
  payload: {
    data: { serviceProviderId, optIn },
    promise: service.setCategoryOptIns(serviceProviderId, [optIn]),
  },
});


export const updateCategoryList = (categories: Array<Category>):
{|payload: {|categories: Array<Category>|}, type: any|} => ({
  type: actionKeys.UPDATE_CATEGORY_LIST,
  payload: { categories },
});

export const filterCategoryList = (categoryIds: Array<number>):
{|payload: {|categoryIds: Array<number>|}, type: any|} => ({
  type: actionKeys.FILTER_CATEGORY_LIST,
  payload: { categoryIds },
});

export const updateOptIns = (categoryId: number, optIns: Array<CategoryOptIn>):
{|payload: {|categoryId: number, optIns: Array<CategoryOptIn>|}, type: any|} => ({
  type: actionKeys.UPDATE_OPT_INS,
  payload: { categoryId, optIns },
});



// WEBPACK FOOTER //
// ./src/app/common/categories/categoriesActions.js